import React from 'react'

const Banner = () => {
    return (
        <div>
            <div id="minimal-bootstrap-carousel" data-ride="carousel" class="carousel slide carousel-fade shop-slider full_width">
                {/* <!-- Wrapper for slides--> */}
                <div role="listbox" class="carousel-inner ver_new_2_slider">
                    <div

                        style={{
                            position: "relative",
                            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(img/agriculture_img.jpg)", // Black shadow overlay
                            backgroundPosition: "center right",
                            backgroundSize: "cover",
                            height: "100vh",
                        }}
                        class="item  active slide-1">
                        <div class="carousel-caption">
                            <div class="thm-container txt-left">
                                <div class="box valign-middle">
                                    <div class="content cnt_wdt1">
                                        <h1 data-animation="animated fadeInUp" class="bnrfnt45">
                                            TRANSFORMING IDEAS INTO RELIABLE SOLUTIONS
                                        </h1>
                                        <p data-animation="animated fadeInDown" class="pln_he">Turning innovative ideas into dependable, <br />
                                            high-quality solutions that drive success and inspire progress.</p>
                                        <a data-animation="animated fadeInUp" href="aboutUs"
                                            class="view-all  slide_learn_btn second_var_slide_btn">Know more</a>
                                        <a data-animation="animated fadeInUp" href="/projects/EOL-for-Motor-Controller-Unit"
                                            class="view-all  slide_learn_btn second_var_slide_btn knw_more_btn">Our Solutions</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{

                            position: "relative",
                            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(img/automation2.jpg)", // Black shadow overlay
                            backgroundPosition: "center right",
                            backgroundSize: "cover",
                            height: "100vh",

                        }}
                        class="item   slide-1">
                        <div class="carousel-caption">
                            <div class="thm-container txt-left">
                                <div class="box valign-middle">
                                    <div class="content cnt_wdt1">
                                        <h1 data-animation="animated fadeInUp" class="bnrfnt45">
                                            Innovation in Research<br />
                                            & Manufacturing
                                        </h1>
                                        <p data-animation="animated fadeInDown" class="pln_he">Driving breakthroughs in research and manufacturing <br />
                                            with innovation, technology, and creativity.</p>
                                        <a data-animation="animated fadeInUp" href="aboutUs"
                                            class="view-all  slide_learn_btn second_var_slide_btn">Know more</a>
                                        <a data-animation="animated fadeInUp" href="/projects/EOL-for-Motor-Controller-Unit"
                                            class="view-all  slide_learn_btn second_var_slide_btn knw_more_btn">Our Solutions</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{

                            position: "relative",
                            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(img/automation4.jpg)", // Black shadow overlay
                            backgroundPosition: "center right",
                            backgroundSize: "cover",
                            height: "100vh",

                        }}
                        class="item   slide-1">
                        <div class="carousel-caption">
                            <div class="thm-container txt-left">
                                <div class="box valign-middle">
                                    <div class="content cnt_wdt1">
                                        <h1 data-animation="animated fadeInUp" class="bnrfnt45">
                                            Engineering Products and solutions
                                        </h1>
                                        <p data-animation="animated fadeInDown" class="pln_he">Precision-engineered products and solutions <br />
                                            designed for efficiency, innovation, and lasting performance</p>
                                        <a data-animation="animated fadeInUp" href="aboutUs"
                                            class="view-all  slide_learn_btn second_var_slide_btn">Know more</a>
                                        <a data-animation="animated fadeInUp" href="/projects/EOL-for-Motor-Controller-Unit"
                                            class="view-all  slide_learn_btn second_var_slide_btn knw_more_btn">Our Solutions</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            position: "relative",
                            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(img/automation.jpg)", // Black shadow overlay
                            backgroundPosition: "center right",
                            backgroundSize: "cover",
                            height: "100vh", // Adjust as needed
                        }}
                        className="item slide-1"
                    >
                        <div className="carousel-caption">
                            <div className="thm-container txt-left">
                                <div className="box valign-middle">
                                    <div className="content cnt_wdt1">
                                        <h1 data-animation="animated fadeInUp" className="bnrfnt45">
                                            Pioneering Excellence in  <br /> Research & Manufacturing

                                        </h1>
                                        <p data-animation="animated fadeInDown" className="pln_he">
                                            Empowering industries with cutting-edge technology, innovation, <br /> and precision engineering for a smarter future

                                        </p>
                                        <a
                                            data-animation="animated fadeInUp"
                                            href="aboutUs"
                                            className="view-all slide_learn_btn second_var_slide_btn"
                                        >
                                            Know more
                                        </a>
                                        <a
                                            data-animation="animated fadeInUp"
                                            href="/projects/EOL-for-Motor-Controller-Unit"
                                            className="view-all slide_learn_btn second_var_slide_btn knw_more_btn"
                                        >
                                            Our Solutions
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* <!-- Controls--> */}
                <a className="left carousel-control" href="#minimal-bootstrap-carousel" role="button" data-slide="prev">
                    <i className="fa fa-angle-left"></i>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="right carousel-control" href="#minimal-bootstrap-carousel" role="button" data-slide="next">
                    <i className="fa fa-angle-right"></i>
                    <span className="sr-only">Next</span>
                </a>

            </div>
            <div class="full_wrapper yellow_bg">
                <div class="container">
                    <div class="innov_txt"> Innovation takes Practice for the Superior Level of Excellence</div>
                    <div class="innove_quote_btn"><a href="contactUs" class="view-all hvr-bounce-to-right get_quote_btn sec_var_quote_btn">Get
                        quote</a></div>
                </div>
            </div>
        </div>
    )
}

export default Banner
